import { useEffect, useState, useRef } from "react";
import { getToken, getUserId, getInizioPeriodo,getFinePeriodo,getLingua } from "../../../auth";
import funzione_collegamento from "../../../funzioni_server/pacchetti_lez_function.js";
import {dizionarioTraduzioni} from "../../../funzioni/traduzioni";
import convertDate from "../../../funzioni/converti_data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUser,
    faUsers,
    faLock,
    faPencil,
    faTrashCan,
    faCircleInfo,
    faSpinner,
    faFileInvoice, faPrint
} from "@fortawesome/free-solid-svg-icons";
import "../../../stili/tabelle.css";
import ReactDOM from "react-dom/client";
import "../../../stili/popup.css";
import  nome_id  from "../../../funzioni/nome_id";
import  status_lezione  from "../../../funzioni/status_lezione";
import  differenzaOrario  from "../../../funzioni/differenza_ore";
import { DateTime } from 'luxon';
import {
    istruttori_disponibili,
    decodificaNazionalita,
    aggiungiTempo,
    criptaRuolo,
    decriptaRuolo,
    sovrapposti, convertiIdNoleggio, convertiTipoStorage, convertiTaglia, convertiColore, convertiIdEscursione,
    convertiValuta
} from "../../../funzioni/funzioni_utili"
import Lottie from "lottie-react";
import animLoading from "../../../assets/loading.json";
import animLoading2 from "../../../assets/loading2.json";
/* global $ */
/* global DevExpress */
const TabellaLezioni =({selectedIndex2}) =>{
const inizioP=DateTime.fromISO(getInizioPeriodo()).toFormat("yyyyMMdd")
const fineP=DateTime.fromISO(getFinePeriodo()).plus({days:1}).toFormat("yyyyMMdd")
    const lingua=getLingua()
function truncate(num, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.trunc(num * factor) / factor;
}
 function openContoFormPopup(initialData, aggiunta) {
  const popup = $("#popupContoEdit").dxPopup("instance");

  popup.option("contentTemplate", function() {
    const container = $("<div>");
    container.dxForm({
      formData: initialData,
      labelLocation: "top",
      items: [
         {
      dataField: "data",
      label: { text: dizionarioTraduzioni(lingua,"Data") },
      template: function(formItem, itemElement) {
        itemElement.empty();

        // Converto il valore iniziale in Date se è ISO:
        let initialValue = formItem.editorOptions?.value || formItem.component.option("formData").data;
        if (typeof initialValue === "string") {
          initialValue = new Date(initialValue);
        }

        $("<div>").appendTo(itemElement).dxDateBox({
          type: "date",
          displayFormat: "dd/MM/yyyy",
          value: initialValue,
          onValueChanged: function(e) {
             const form = formItem.component; // usa il componente passato
    const fd = form.option("formData");
    fd.data = e.value ? e.value.toISOString().slice(0,10) : null;
    form.option("formData", fd);
          }
        });
      }
    },
          { dataField: "nome" },
        { dataField: "note" },

        {
          itemType: "button",
          horizontalAlignment: "right",
          buttonOptions: {
            text: "Salva",
            type: "success",
            onClick: async function() {
              const form = container.dxForm("instance");
              const data = form.option("formData");
              let richiesta;
              const dati= {billcustomer:data.nome,billdate:convertDate(DateTime.fromISO(data.data)),
                billnotes:data.note}
              if (aggiunta){
                   richiesta = await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati,
                        azione:'setBillItem'
                   })
                  const instance = $("#val_conto").dxLookup("instance");
                    const datas=instance.option("dataSource");
                    datas.push({id:richiesta.billid,text:data.nome})
                  instance.option("dataSource",datas)
              }
              else {
                  richiesta= await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati,
                      setId:$("#val_conto").dxLookup("instance").option("value"),
                        azione:'setBillItem'
                   })
                    const instance = $("#val_conto").dxLookup("instance");
                    const datas=instance.option("dataSource");
                    datas.find(x => {
                        if (x.id === instance.option("value")) x.text=data.nome
                    })
                  instance.option("dataSource",datas)
              }
              popup.hide();
            }
          }
        }
      ]
    });
    return container;
  });

  popup.show();
}

function closePacket(pacchetto){
    const contenuto =document.createElement("div")
    contenuto.style.padding = "0px";
    contenuto.innerText = `${dizionarioTraduzioni(lingua,"Sei sicuro di volere chiudere il pacchetto di")} ${pacchetto.nome}?`
    contenuto.style.marginTop = "10px";
    contenuto.style.fontSize = "20px";
    contenuto.style.fontFamily = "Poppins, sans-serif";
    $("#chiusuraPacchetto").dxPopup("instance").option( "title",`${dizionarioTraduzioni(lingua,"Conferma chiusura pacchetto di")} ${pacchetto.nome}`);
    $("#chiusuraPacchetto").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#chiusuraPacchetto").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        stylingMode: 'contained',
        text: dizionarioTraduzioni(lingua,'Salva'),
        onClick: async function () {
            $("#loadingOverlay").show()
            const dati={"lessonpacket":truncate(pacchetto.oreTot,2)};
            const  richiesta= await funzione_collegamento({
                userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati,
        setId:pacchetto.lessonid,
        azione:'setLesson'
            })
            const datagen = await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        filtri:{"lessondatestatus":2,"lessonsfrom":inizioP,"lessonsto":fineP},
        azione:'getLessons'
      });

      $("#gridContainer").addClass("grid-container-hidden");
      let data=[]
      if (selectedIndex2===0)  {data=datagen}
      else   {
        for (let i of datagen) {
            if  (Math.abs(i.lessonhours-i.lessonpacket)>0.05 && i["lessonhours"]<i["lessonpacket"]+0.05) {
                if (selectedIndex2===2 | i["lessonhours"]+0.05>i["lessonpacket"]) {
                    data=[...data,i]
                    }
            }
            else {
                if (selectedIndex2===1) {
                    data=[...data,i]
                    }
            }
        }
      }
      const formattedRows = data.map((row, index) => ({
        id: index,
        lessonid:row.lessonid,
        data: convertDate(row.lessonregdate).toISO({ includeOffset: false }),
        nome: row.lessonstudentname,
        pacchetto: row.lessonpacket,
        tipo: row.lessontype,
        costo: row.lessoncost,
        gruppoSingola: row.lessonnumstudents,
        pagamento: row.lessonpaymentmethod,
        anticipo: row.lessonadvance,
        sconto:row.lessondiscount,
        telefono:row.lessonstudentphone,
        sesso:row.lessonstudentsex,
        eta:row.lessonstudentage,
        origine:row.lessonstudentorigin,
        periodo:[row.lessonclientarrival,row.lessonclientdeparture],
        nonDisp:row.lessonclientunavailable,
        costo_scontato: (row.lessoncost * (1 - (row.lessondiscount || 0) / 100)),
        oreTot:row.lessonhours,
          conto:row.billid,
          invoiceid:row.invoiceid,
      }));
      $("#gridContainer").dxDataGrid("instance").option("dataSource", formattedRows);
      $("#gridContainer").removeClass("grid-container-hidden");
      $("#chiusuraPacchetto").dxPopup("instance").hide();

            }
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: dizionarioTraduzioni(lingua,'Chiudi'),
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#chiusuraPacchetto").dxPopup("instance").hide();
        },
      },
    }],)
    $("#chiusuraPacchetto").dxPopup("instance").show();
}
function generaInterfacciaFattura(dati){
    const allineamento="center"
    const divGen=document.createElement("div")
    const divSalva=document.createElement("div")
    divSalva.id="bottoneSalva"
    divSalva.style.marginTop="10px"
    divGen.appendChild(divSalva)
    const divIntest=document.createElement("div")
    divIntest.id="intestazione"
    const divRighe=document.createElement("div")
    divRighe.id="righe"
    divGen.appendChild(divIntest)
    divGen.appendChild(divRighe)
    let righe=[]
    let quantita={}
    let giaMesse=[]
    for (let lezione of [dati]){
        if (!(lezione.pacchetto in quantita)) quantita[lezione.pacchetto]={"costo":0,"quantita":0}
        quantita[lezione.pacchetto]["quantita"]+=1
        quantita[lezione.pacchetto]["costo"]+=(lezione.costo_scontato)
    }
    for (let lezione of [dati]){
        if (!giaMesse.includes(lezione.pacchetto))
        righe.push({pagato:lezione.anticipo,"invoicerowdescr":`${lezione.pacchetto}H kitesurfing lesson package`,"invoicerowcurrency":1,"invoicerowquant":quantita[lezione.pacchetto]["quantita"],"invoicerownetunitvalue":quantita[lezione.pacchetto]["costo"]/quantita[lezione.pacchetto]["quantita"],"invoicerownettotvalue":quantita[lezione.pacchetto]["costo"],"invoicerowgrosstotvalue":quantita[lezione.pacchetto]["costo"]})
        giaMesse.push(lezione.pacchetto)
    }
    setTimeout(()=> {
        $("#bottoneSalva").dxCheckBox({
            text:dizionarioTraduzioni(lingua,"Salva fattura"),
            value:false,
        })
        $("#intestazione").dxDataGrid({
            dataSource:[],
            editing: {
                mode: "popup",
                allowUpdating: true,
                allowAdding: true,
                allowDeleting: true,
                useIcons: true,
                popup: {
                    title: dizionarioTraduzioni(lingua,"Modifica intestazione"),
                    showTitle: true,
                    width: "80%",
                    height: "auto",
                    maxHeight: "90%",
                }
            },
            columns: [
             { dataField: "invoicecustomer", alignment:allineamento,caption: dizionarioTraduzioni(lingua,"Nome Fattura"),hidingPriority:9},
          {
            dataField: "invoicedate",
            caption: dizionarioTraduzioni(lingua,"Data"),
            sortOrder: "desc",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg_int").length===0) {
                $('<div id="val_reg_int"></div>').appendTo(cellElement)
            }
            $("#val_reg_int").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 7,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
            { dataField: "invoiceaddress", alignment:allineamento,caption: dizionarioTraduzioni(lingua,"Indirizzo cliente"),hidingPriority:2,
        },
            { dataField: "invoicecontacts", alignment:allineamento,caption: dizionarioTraduzioni(lingua,"contatti cliente"),hidingPriority:3,
        },
        { dataField: "invoicenotes", alignment:allineamento,caption: dizionarioTraduzioni(lingua,"Note fattura"),hidingPriority:1,
        },
            { dataField: "invoicenumber", alignment:allineamento,caption: dizionarioTraduzioni(lingua,"Numero fattura"),hidingPriority:4,
        },
            {dataField:"invoicecurrency",
            visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }},

          {
            type: "buttons",
            minWidth:140,
            buttons: [

              {
                hint: dizionarioTraduzioni(lingua,"Modifica"),
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },

              {
                hint: dizionarioTraduzioni(lingua,"Elimina"),
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
            ],
          },
          ],
        })
        $("#righe").dxDataGrid({
            dataSource:righe,
            editing: {
                mode: "popup",
                allowUpdating: true,
                allowAdding: true,
                allowDeleting: true,
                useIcons: true,
                popup: {
                    title: dizionarioTraduzioni(lingua,"Modifica righe"),
                    showTitle: true,
                    width: "80%",
                    height: "auto",
                    maxHeight: "90%",
                }
            },
             columns:[
                {"dataField":"invoicerowdescr","caption":dizionarioTraduzioni(lingua,"Descrizione"), hidingPriority:5},
                {"dataField":"invoicerowquant",caption:dizionarioTraduzioni(lingua,"Quantità"),hidingPriority:2,
                editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_quantita_righe").length===0) {
                $('<div id="val_quantita_righe"></div>').appendTo(cellElement)
            }
            $("#val_quantita_righe").dxNumberBox({value:cellInfo.value,minValue:0,onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                    $("#val_netto").dxNumberBox("instance").option("value",$("#val_unitario").dxNumberBox("instance").option("value")*e.value)
            }})
          }
                },
                { dataField: "invoicerowcurrency",visible:false, caption: dizionarioTraduzioni(lingua,"Valuta"),hidingPriority:5,customizeText: function (e){
          return convertiValuta(e.value)},
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_netto").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
                    $("#val_unitario").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
                    $("#val_gross").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)

            }})
          },
        },
                {"dataField":"invoicerownetunitvalue","caption":dizionarioTraduzioni(lingua,"Costo unitario"),hidingPriority:3,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_unitario").length===0) {
                $('<div id="val_unitario"></div>').appendTo(cellElement)
            }
            $("#val_unitario").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                    $("#val_netto").dxNumberBox("instance").option("value",$("#val_quantita_righe").dxNumberBox("instance").option("value")*e.value)
            }})
          }
                },
                {"dataField":"invoicerownettotvalue","caption":dizionarioTraduzioni(lingua,"Costo netto totale"),hidingPriority:4,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_netto").length===0) {
                $('<div id="val_netto"></div>').appendTo(cellElement)
            }
            $("#val_netto").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }
                },

                {"dataField":"pagato","caption":dizionarioTraduzioni(lingua,"Pagato"),hidingPriority:1,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_pag_in").length===0) {
                $('<div id="val_pag_in"></div>').appendTo(cellElement)
            }
            $("#val_pag_in").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }
                },

            ],
            columnAutoWidth: true,
        columnHidingEnabled: true,
        })

    },0)
    return divGen

}
function DynamicLessonButton2({ cellInfo, }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    $("#loadingOverlay").show();
     setLoading(true);
     if (!cellInfo.data.invoiceid) {
         const content = generaInterfacciaFattura(cellInfo.data)
         $("#fattura").dxPopup("instance").option(
             "title",
             dizionarioTraduzioni(lingua,`Fattura`)
         );
         $("#fattura").dxPopup("instance").option("contentTemplate", () => content);
         $("#fattura").dxPopup("instance").show();
         $("#fattura").dxPopup("instance").option("toolbarItems", [{
             widget: 'dxButton',
             toolbar: 'bottom',
             location: 'after',
             options: {
                 stylingMode: 'contained',
                 text: dizionarioTraduzioni(lingua,'Salva'),
                 onClick: async function () {
                     let intestazioniR = $("#intestazione").dxDataGrid("instance").option("dataSource")[0]
                     delete intestazioniR["__KEY__"]
                     let totalePagato = 0
                     let totale = 0
                     let righe = $("#righe").dxDataGrid("instance").option("dataSource")
                     for (let riga of righe) {
                         totale += riga.invoicerownettotvalue
                         totalePagato += riga.pagato

                     }
                     intestazioniR["invoicedate"] = DateTime.fromISO(intestazioniR["invoicedate"]).toFormat("yyyyMMdd")
                     intestazioniR["invoicenetvalue"] = totale
                     intestazioniR["invoicegrossvalue"] = totale
                     intestazioniR["invoiceadvance"] = totalePagato
                     intestazioniR["invoicetopay"] = totale - totalePagato

                     let richiestaFattura = await funzione_collegamento({
                         userid: getUserId(),
                         token: getToken(),
                         logout_on_error: true,
                         valori: intestazioniR,
                         azione: 'setInvoice'
                     })
                     const idFattura = richiestaFattura.invoiceid
                     let richiestaRiga
                     for (let riga of righe) {
                         delete riga.__KEY__
                         riga["invoiceid"] = idFattura
                         richiestaRiga = await funzione_collegamento({
                             userid: getUserId(),
                             token: getToken(),
                             logout_on_error: true,
                             valori: riga,
                             azione: 'setInvoiceRow'
                         })
                     }
                     const fatturaRich = await funzione_collegamento({
                         userid: getUserId(),
                         token: getToken(),
                         logout_on_error: true,
                         filtri: {getid: idFattura},
                         azione: 'generateInvoice'
                     })
                     if (!$("#bottoneSalva").dxCheckBox("instance").option("value")) {
                         richiestaFattura = await funzione_collegamento({
                             userid: getUserId(),
                             token: getToken(),
                             logout_on_error: true,
                             delId: idFattura,
                             azione: 'delInvoice'
                         })
                     }
                     else{
                         const rich=await funzione_collegamento({
                           userid: getUserId(),
                            token: getToken(),
                            logout_on_error: true,
                            setId:cellInfo.data.lessonid,
                            valori: {invoiceid:idFattura},
                            azione:'setLesson'})
                         const datagen = await funzione_collegamento({
                            userid: getUserId(),
                            token: getToken(),
                            logout_on_error: true,
                            filtri:{"lessondatestatus":2,"lessonsfrom":inizioP,"lessonsto":fineP},
                            azione:'getLessons'
                          });
                          let data=[]
                          if (selectedIndex2===0)  {data=datagen}
                          else   {
                            for (let i of datagen) {
                                if  (Math.abs(i.lessonhours-i.lessonpacket)>0.05 && i["lessonhours"]<i["lessonpacket"]+0.05) {
                                    if (selectedIndex2===2 | i["lessonhours"]+0.05>i["lessonpacket"]) {
                                        data=[...data,i]
                                        }
                                }
                                else {
                                    if (selectedIndex2===1) {
                                        data=[...data,i]
                                        }
                                }
                            }
                          }
                          const formattedRows = data.map((row, index) => ({
                            id: index,
                            lessonid:row.lessonid,
                            data: convertDate(row.lessonregdate).toISO({ includeOffset: false }),
                            nome: row.lessonstudentname,
                            pacchetto: row.lessonpacket,
                            tipo: row.lessontype,
                            costo: row.lessoncost,
                            gruppoSingola: row.lessonnumstudents,
                            pagamento: row.lessonpaymentmethod,
                            anticipo: row.lessonadvance,
                            sconto:row.lessondiscount,
                            telefono:row.lessonstudentphone,
                            sesso:row.lessonstudentsex,
                            eta:row.lessonstudentage,
                            origine:row.lessonstudentorigin,
                            periodo:[row.lessonclientarrival,row.lessonclientdeparture],
                            nonDisp:row.lessonclientunavailable,
                            costo_scontato: (row.lessoncost * (1 - (row.lessondiscount || 0) / 100)),
                            oreTot:row.lessonhours,
                            conto:row.billid,
                              invoiceid:row.invoiceid,
                          }));
                          $("#gridContainer").dxDataGrid("instance").option("dataSource", formattedRows);
                     }
                     const baseURL = "https://jckite.mogaverocompany.co.ke";
                     const fileURL = fatturaRich.invoicepdf ? fatturaRich.invoicepdf.startsWith("http")
                         ? fatturaRich.invoicepdf
                         : `${baseURL}${fatturaRich.invoicepdf.startsWith("/") ? "" : "/"}${fatturaRich.invoicepdf}` : "";

                     window.open(fileURL, "_blank");
                 }
             }
         }, {
             widget: 'dxButton',
             toolbar: 'bottom',
             location: 'after',
             options: {
                 text: dizionarioTraduzioni(lingua,'Chiudi'),
                 stylingMode: 'outlined',
                 type: 'normal',
                 onClick() {
                     $("#fattura").dxPopup("instance").hide();
                 },
             },
         }],)
         $("#loadingOverlay").hide();
         setLoading(false);
     }
     else{
         const baseURL = "https://jckite.mogaverocompany.co.ke";
         const url1=await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        filtri:{getid:cellInfo.data.invoiceid},
        azione:'getInvoice'
      });
         const url=url1[0]
         const fileURL = url.invoicepdf?url.invoicepdf.startsWith("http")
            ? url.invoicepdf
            : `${baseURL}${url.invoicepdf.startsWith("/") ? "" : "/"}${url.invoicepdf}`:"";
         $("#loadingOverlay").hide();
     setLoading(false);
         window.open(fileURL, "_blank")

     }
  };

  return (
    <BounceIconButton
      icon={loading ? faSpinner : faFileInvoice}
       className={loading ? 'spin-icon' : ''}
      color="#46dbf2"
      onClick={loading ? null : handleClick}
    />
  );
}
function DynamicLessonButton({ cellInfo, }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    $("#loadingOverlay").show();
     setLoading(true);

          const content = await mostraPopupInfoLezione(
            cellInfo.data.lessonid,cellInfo.data.nome
          );

          $("#loadingOverlay").hide();  // Nasconde overlay
            setLoading(false);
          $("#infoPopup").dxPopup("instance").option(
            "title",
            `${dizionarioTraduzioni(lingua,"Dettagli lezioni di")} ${cellInfo.data.nome}`
          );
          $("#infoPopup").dxPopup("instance").option("contentTemplate", () => content);
          $("#infoPopup").dxPopup("instance").show();
  };

  return (
    <BounceIconButton
      icon={loading ? faSpinner : faCircleInfo}
       className={loading ? 'spin-icon' : ''}
      color="#46dbf2"
      onClick={loading ? null : handleClick}
    />
  );
}

async function mostraPopupInfoLezione(id,nome) {
  const allineamento="center"
  const lez_pac_gen = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLessonDates",
    filtri: { lessonid: id,},
  });
  let lez_pac=[]
  let lez_pach_prog=[]
  for (let i of lez_pac_gen){
    if (i.lessondatestatus===2){
        lez_pac.push(i)
    }
    else if (i.lessondatestatus===1){
        lez_pach_prog.push(i)
    }
  }
  const utenti = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:'getUsers'
  });
  const formattedRows2 = lez_pac.map((row, index) => ({
    id: index,
    lessondateid:row.lessondateid,
    inizio: convertDate(row.lessondatestart).toISO({ includeOffset: false }),
    fine: convertDate(row.lessondateend).toISO({ includeOffset: false }),
    durata: convertDate(row.lessondateend)-convertDate(row.lessondatestart),
    istruttore: nome_id({id:row.userid, utenti:utenti}),
    status: dizionarioTraduzioni(lingua,status_lezione(row.lessondatestatus)),
    livello: row.lessondatelevelreached,
  }));
  const formattedRows3 = lez_pach_prog.map((row, index) => ({
    id: index,
    lessondateid:row.lessondateid,
    inizio: convertDate(row.lessondatestart).toISO({ includeOffset: false }),
    fine: convertDate(row.lessondateend).toISO({ includeOffset: false }),
    durata: convertDate(row.lessondateend)-convertDate(row.lessondatestart),
    istruttore: nome_id({id:row.userid, utenti:utenti}),
    status: dizionarioTraduzioni(lingua,status_lezione(row.lessondatestatus)),
    livello: row.lessondatelevelreached,
  }));
  const div = document.createElement("div");
  div.style.padding = "0px";
  const titolo1=document.createElement("h3")
  titolo1.innerText=dizionarioTraduzioni(lingua,"Ore concluse")
  titolo1.style.fontFamily = "Poppins, sans-serif";
  titolo1.style.marginBottom="0px"
  div.appendChild(titolo1)
  const inner = document.createElement("div");
  inner.id = "gridContainerSecond";
  div.appendChild(inner);
  const titolo2=document.createElement("h3")

  titolo2.innerText=dizionarioTraduzioni(lingua,"Ore Programmate")
  titolo2.style.fontFamily = "Poppins, sans-serif";
  titolo2.style.marginBottom="0px"
  if (lez_pach_prog.length!==0)
  div.appendChild(titolo2)
  if (lez_pach_prog.length!==0){
  const inner2=document.createElement("div");
  inner2.id = "gridContainerSecondProg";

  div.appendChild(inner2);}
  const commento = document.createElement("p");
  let totale_ore=0
  let totale_ore_prog=0
  for (let i of lez_pac) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
  totale_ore+=diffMs}
  for (let i of lez_pach_prog) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
  totale_ore+=diffMs
  totale_ore_prog+=diffMs}
  if (totale_ore_prog===0)
  commento.innerText = `${dizionarioTraduzioni(lingua,"Ore totali di short__prefix")} ${nome}: ${differenzaOrario({dataInizio:totale_ore})}`
  else commento.innerText = `${dizionarioTraduzioni(lingua,"Ore totali di__prefix")} ${nome}: ${differenzaOrario({dataInizio:totale_ore})}, ${dizionarioTraduzioni(lingua,"Ore totali di__middle")} ${differenzaOrario({dataInizio:totale_ore-totale_ore_prog})} ${dizionarioTraduzioni(lingua,"Ore totali di__completed")} ${dizionarioTraduzioni(lingua,"e")} ${differenzaOrario({dataInizio:totale_ore_prog})} ${dizionarioTraduzioni(lingua,"Ore totali di__scheduled")}`
  commento.style.marginTop = "10px";
  commento.style.fontWeight = "bold";
  commento.style.fontSize = "24px";
  commento.style.fontFamily = "Poppins, sans-serif";
  div.appendChild(commento);
  setTimeout(() => {
    $("#gridContainerSecond").dxDataGrid({
      dataSource: formattedRows2,
      columns: [
        {
          dataField: "inizio",
          caption: dizionarioTraduzioni(lingua,"Data e ora inizio"),
          hidingPriority:5,
          alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_inizio").length===0) {
                $('<div id="val_inizio"></div>').appendTo(cellElement)
            }
            $("#val_inizio").dxDateBox({type:"datetime",format: "dd/MM/yyyy HH:mm",displayFormat :"dd/MM/yyyy HH:mm",value:cellInfo.value, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          }
        },
        { dataField: "fine", alignment:allineamento,caption: dizionarioTraduzioni(lingua,"Data e ora fine"), hidingPriority:4,customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          }, editorType: 'dxDateBox',
            editorOptions: {
            displayFormat: "dd/MM/yyyy",
  },},
        { dataField: "durata", alignment:allineamento,caption: dizionarioTraduzioni(lingua,"Durata lezione"),hidingPriority:6,customizeText: function (e) {

            return differenzaOrario({dataInizio:e.value},);
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_durata_lez").length===0) {
                $('<div id="val_durata_lez"></div>').appendTo(cellElement)
            }
            const diffMin_or = Math.floor(cellInfo.value / 60000); // millisecondi in minuti
            const ore_ad = Math.floor(diffMin_or / 60);
            const minuti_ad = diffMin_or % 60;
            $("#val_durata_lez").dxTextBox({mask:'0:00',value: minuti_ad<10 ? `${ore_ad}:0${minuti_ad}`:`${ore_ad}:${minuti_ad}` , onValueChanged: function(e) {
            const durationString = e.value;
            const hours = parseInt(durationString[0])
            const minutes =parseInt(durationString.slice(1, 3))
            const valoreInMs = (hours * 60 + minutes) * 60000;
            cellInfo.setValue(valoreInMs);

            }})
          }
        },
        { dataField: "istruttore",alignment:allineamento, caption: dizionarioTraduzioni(lingua,"Istruttore") ,hidingPriority:3,

        editCellTemplate: async function  (cellElement,cellInfo) {
          if ($("#val_istruttore").length===0) {
                $('<div id="val_istruttore"></div>').appendTo(cellElement)
            }
             const rowData = cellInfo.row.data;
            const ora_in=$("#val_inizio").dxDateBox("instance").option("value")
            const durat=$("#val_durata_lez").dxTextBox("instance").option("value")
            const utenti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                azione:'getUsers'
              });
            const istruttoriDisponibili= await istruttori_disponibili({dataInizio:DateTime.fromISO(ora_in).toMillis(),dataFine:DateTime.fromISO(ora_in).toMillis()+rowData.durata,id_lezione:lez_pac[rowData.id]?.lessondateid ?? 0,utenti:utenti});
            $("#val_istruttore").dxSelectBox({dataSource:istruttoriDisponibili , value:rowData.istruttore,onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              },
            })
          },
        },
        { dataField: "status",alignment:allineamento, caption: dizionarioTraduzioni(lingua,"Status Lezione"), hidingPriority:2,
         editCellTemplate: function  (cellElement,cellInfo) {
          if ($("#val_status").length===0) {
                $('<div id="val_status"></div>').appendTo(cellElement)
            }
            const dati_id_c=[{ID:1,name:dizionarioTraduzioni(lingua,"Programmata")},{ID:2,name:dizionarioTraduzioni(lingua,"Conclusa")},{ID:3,name:dizionarioTraduzioni(lingua,"Cancellata")},{ID:4,name:dizionarioTraduzioni(lingua,"No Show")}]
            $("#val_status").dxSelectBox({dataSource: dati_id_c,displayExpr:"name",valueExpr:"ID", value:status_lezione(cellInfo.value),

            onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              }
            },)

          }},
        { dataField: "livello",alignment:allineamento, caption: dizionarioTraduzioni(lingua,"Livello raggiunto"), hidingPriority:1 },
        {
            type: "buttons",
            minWidth:120,
            buttons: [
              {
                hint: dizionarioTraduzioni(lingua,"Modifica"),
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },

              {
                hint: dizionarioTraduzioni(lingua,"Elimina"),
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },]}
      ],
      showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `${dizionarioTraduzioni(lingua,"Modifica lezione di")} ${nome}`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "inizio","durata","istruttore","status",
                ],
              },
              {
                itemType: "group",
                colCount: 1,
                colSpan: 2,
                items: ["livello"
                ],
              },
            ],
          },
          },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainerSecond"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
     const jsDate = new Date(e.data.inizio);
    const baseDate2 = DateTime.fromJSDate(jsDate)
    const basedate2iso=baseDate2.toISO({ includeOffset: false })
    const baseDate=DateTime.fromISO(basedate2iso,{ zone: "Africa/Nairobi" })
    const updatedDate = baseDate.plus({ milliseconds:e.data.durata });
    const istruttore=nome_id({nome:e.data.istruttore,utenti:utenti})
    let statusLez
    if (typeof e.data.status==="string"){ statusLez=status_lezione(e.data.status)}
    else { statusLez=(e.data.status)}
    const dati_n={"lessondatestart":convertDate(DateTime.fromISO(baseDate),false,true),"lessondateend":convertDate(updatedDate,false,true),"userid":istruttore,"lessondatestatus":statusLez,"lessondatelevelreached":e.data.livello,};
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.lessondateid,
        valori:dati_n,
        azione:'setLessonDate'})
        if (richiesta) {
            const message = `Lezione di ${nome} modificata con successo`;

            window.DevExpress.ui.notify({message,
            position: {
              my: 'center',
              at: 'center',
              of: '#gridContainerSecond',
            },}, "success", 1000);
            let totale_ore=0
            for (let i of lez_pac) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
            totale_ore+=diffMs}
            totale_ore+=(e.data.durata-(convertDate(lez_pac[e.data.id]["lessondateend"])-convertDate(lez_pac[e.data.id]["lessondatestart"])))
            commento.innerText =  `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}`
        }

    },

    onRowRemoving: async function (e) {

    const richiesta=  await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        delId:e.data.lessondateid,
        azione:'delLessonDate',
        return_data:false})
    if (richiesta) {
        const message = `Lezione di ${nome} eliminata con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerSecond',
        },}, "success", 1000);}


},
    onRowInserting: async function (e) {

        // Aggiungi la classe di animazione alla griglia
        $("#loadingOverlay").show();
         $("#gridContainerSecond").addClass("grid-container-hidden");


    const jsDate = new Date(e.data.inizio);
    const baseDate2 = DateTime.fromJSDate(jsDate)
    const basedate2iso=baseDate2.toISO({ includeOffset: false })
    const baseDate=DateTime.fromISO(basedate2iso,{ zone: "Africa/Nairobi" })
    const updatedDate = baseDate.plus({ milliseconds:e.data.durata });
    const istruttore=nome_id({nome:e.data.istruttore,utenti:utenti})
    const dati={"lessonid":id,"lessondatestart":convertDate(DateTime.fromISO(baseDate),false,true),"lessondateend":convertDate(updatedDate,false,true),"userid":istruttore,"lessondatestatus":e.data.status,"lessondatelevelreached":e.data.livello,};
    const richiesta= await  funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati,
        azione:'setLessonDate'})
    if (richiesta) {
        const message = `${dizionarioTraduzioni(lingua,"Lezione aggiunta__prefix")} ${nome} ${dizionarioTraduzioni(lingua,"Lezione aggiunta__suffix")}`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerSecond',

        },}, "success", 1000);
        const lez_pac = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLessonDates",
    filtri: { lessonid: id,lessondatestatus:2 },
  });
      const formattedRows2 = lez_pac.map((row, index) => ({
    id: index,
    inizio: convertDate(row.lessondatestart).toISO({ includeOffset: false }),
    fine: convertDate(row.lessondateend).toISO({ includeOffset: false }),
    durata: convertDate(row.lessondateend)-convertDate(row.lessondatestart),
    istruttore: nome_id({id:row.userid, utenti:utenti}),
    status: status_lezione(row.lessondatestatus),
    livello: row.lessondatelevelreached,
  }));
  let totale_ore=0
  for (let i of lez_pac) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
  totale_ore+=diffMs}
  commento.innerText =  `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}`
      e.component.option("dataSource", formattedRows2);
      setTimeout(() => {
            $("#gridContainerSecond").removeClass("grid-container-hidden");
            $("#loadingOverlay").hide();
        }, 100);
        }
    },
    onCellClick: function(e) {
                if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {

      const masterRow = e.component.getRowElement(e.row.rowIndex);
      const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
      if (!($icon.length)) {
      const masterRow = e.component.getRowElement(e.row.rowIndex);
      const $icon = masterRow.find(".dx-datagrid-adaptive-more");
      if ($icon.length){
      $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
      }
      else
      {
      $icon[0].className = "dx-datagrid-adaptive-more";
      }}

    },

    });
    if (totale_ore_prog!==0){
    $("#gridContainerSecondProg").dxDataGrid({
      dataSource: formattedRows3,
      columns: [
        {
          dataField: "inizio",
          caption: dizionarioTraduzioni(lingua,"Data e ora inizio"),
          hidingPriority:5,
          alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_inizio").length===0) {
                $('<div id="val_inizio"></div>').appendTo(cellElement)
            }
            $("#val_inizio").dxDateBox({type:"datetime",format: "dd/MM/yyyy HH:mm",displayFormat :"dd/MM/yyyy HH:mm",value:cellInfo.value, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          }
        },
        { dataField: "fine", alignment:allineamento,caption: dizionarioTraduzioni(lingua,"Data e ora fine"), hidingPriority:4,customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          }, editorType: 'dxDateBox',
            editorOptions: {
            displayFormat: "dd/MM/yyyy",
  },},
        { dataField: "durata", alignment:allineamento,caption: dizionarioTraduzioni(lingua,"Durata lezione"),hidingPriority:6,customizeText: function (e) {

            return differenzaOrario({dataInizio:e.value},);
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_durata_lez").length===0) {
                $('<div id="val_durata_lez"></div>').appendTo(cellElement)
            }
            const diffMin_or = Math.floor(cellInfo.value / 60000); // millisecondi in minuti
            const ore_ad = Math.floor(diffMin_or / 60);
            const minuti_ad = diffMin_or % 60;
            $("#val_durata_lez").dxTextBox({mask:'0:00',value: minuti_ad<10 ? `${ore_ad}:0${minuti_ad}`:`${ore_ad}:${minuti_ad}` , onValueChanged: function(e) {
            const durationString = e.value;
            const hours = parseInt(durationString[0])
            const minutes =parseInt(durationString.slice(1, 3))
            const valoreInMs = (hours * 60 + minutes) * 60000;
            cellInfo.setValue(valoreInMs);

            }})
          }
        },
        { dataField: "istruttore",alignment:allineamento, caption: dizionarioTraduzioni(lingua,"Istruttore") ,hidingPriority:3,

        editCellTemplate: async function  (cellElement,cellInfo) {
          if ($("#val_istruttore").length===0) {
                $('<div id="val_istruttore"></div>').appendTo(cellElement)
            }
             const rowData = cellInfo.row.data;
            const ora_in=$("#val_inizio").dxDateBox("instance").option("value")
            const durat=$("#val_durata_lez").dxTextBox("instance").option("value")
            const utenti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                azione:'getUsers'
              });
            const istruttoriDisponibili= await istruttori_disponibili({dataInizio:DateTime.fromISO(ora_in).toMillis(),dataFine:DateTime.fromISO(ora_in).toMillis()+rowData.durata,id_lezione:lez_pac[rowData.id]?.lessondateid ?? 0,utenti:utenti});
            $("#val_istruttore").dxSelectBox({dataSource:istruttoriDisponibili , value:rowData.istruttore,onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              },
            })
          },
        },
        { dataField: "status",alignment:allineamento, caption: dizionarioTraduzioni(lingua,"Status Lezione"), hidingPriority:2,
         editCellTemplate: function  (cellElement,cellInfo) {
          if ($("#val_status").length===0) {
                $('<div id="val_status"></div>').appendTo(cellElement)
            }
            const dati_id_c=[{ID:1,name:dizionarioTraduzioni(lingua,"Programmata")},{ID:2,name:dizionarioTraduzioni(lingua,"Conclusa")},{ID:3,name:dizionarioTraduzioni(lingua,"Cancellata")},{ID:4,name:dizionarioTraduzioni(lingua,"No Show")}]
            $("#val_status").dxSelectBox({dataSource: dati_id_c,displayExpr:"name",valueExpr:"ID", value:status_lezione(cellInfo.value),

            onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              }
            },)

          }},
        { dataField: "livello",alignment:allineamento, caption: dizionarioTraduzioni(lingua,"Livello raggiunto"), hidingPriority:1 },
        {
            type: "buttons",
            minWidth:80,
            buttons: [
              {
                hint: dizionarioTraduzioni(lingua,"Modifica"),
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: dizionarioTraduzioni(lingua,"Elimina"),
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },]}
      ],
      showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `${dizionarioTraduzioni(lingua,"Modifica lezione di")} ${nome}`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "inizio","durata","istruttore","status",
                ],
              },
              {
                itemType: "group",
                colCount: 1,
                colSpan: 2,
                items: ["livello"
                ],
              },
            ],
          },
          },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainerSecond"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
     const jsDate = new Date(e.data.inizio);
    const baseDate2 = DateTime.fromJSDate(jsDate)
    const basedate2iso=baseDate2.toISO({ includeOffset: false })
    const baseDate=DateTime.fromISO(basedate2iso,{ zone: "Africa/Nairobi" })
    const updatedDate = baseDate.plus({ milliseconds:e.data.durata });
    const istruttore=nome_id({nome:e.data.istruttore,utenti:utenti})
    let statusLez
    if (typeof e.data.status==="string"){ statusLez=status_lezione(e.data.status)}
    else { statusLez=(e.data.status)}
    const dati_n={"lessondatestart":convertDate(DateTime.fromISO(baseDate),false,true),"lessondateend":convertDate(updatedDate,false,true),"userid":istruttore,"lessondatestatus":statusLez,"lessondatelevelreached":e.data.livello,};
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.lessondateid,
        valori:dati_n,
        azione:'setLessonDate'})
        if (richiesta) {
            const message = `Lezione di ${nome} modificata con successo`;

            window.DevExpress.ui.notify({message,
            position: {
              my: 'center',
              at: 'center',
              of: '#gridContainerSecond',
            },}, "success", 1000);
            let totale_ore=0
            for (let i of lez_pac) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
            totale_ore+=diffMs}
            totale_ore+=(e.data.durata-(convertDate(lez_pac[e.data.id]["lessondateend"])-convertDate(lez_pac[e.data.id]["lessondatestart"])))
            commento.innerText =  `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}`
        }

    },

    onRowRemoving: async function (e) {

    const richiesta=  await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        delId:e.data.lessondateid,
        azione:'delLessonDate',
        return_data:false})
    if (richiesta) {
        const message = `Lezione di ${nome} eliminata con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerSecond',
        },}, "success", 1000);}


},
    onRowInserting: async function (e) {

        // Aggiungi la classe di animazione alla griglia
        $("#loadingOverlay").show();
         $("#gridContainerSecond").addClass("grid-container-hidden");


    const jsDate = new Date(e.data.inizio);
    const baseDate2 = DateTime.fromJSDate(jsDate)
    const basedate2iso=baseDate2.toISO({ includeOffset: false })
    const baseDate=DateTime.fromISO(basedate2iso,{ zone: "Africa/Nairobi" })
    const updatedDate = baseDate.plus({ milliseconds:e.data.durata });
    const istruttore=nome_id({nome:e.data.istruttore,utenti:utenti})
    const dati={"lessonid":id,"lessondatestart":convertDate(DateTime.fromISO(baseDate),false,true),"lessondateend":convertDate(updatedDate,false,true),"userid":istruttore,"lessondatestatus":e.data.status,"lessondatelevelreached":e.data.livello,};
    const richiesta= await  funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati,
        azione:'setLessonDate'})
    if (richiesta) {
        const message = `Lezione di ${nome} aggiunto con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerSecond',

        },}, "success", 1000);
        const lez_pac = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLessonDates",
    filtri: { lessonid: id,lessondatestatus:2 },
  });
      const formattedRows3 = lez_pach_prog.map((row, index) => ({
    id: index,
    inizio: convertDate(row.lessondatestart).toISO({ includeOffset: false }),
    fine: convertDate(row.lessondateend).toISO({ includeOffset: false }),
    durata: convertDate(row.lessondateend)-convertDate(row.lessondatestart),
    istruttore: nome_id({id:row.userid, utenti:utenti}),
    status: status_lezione(row.lessondatestatus),
    livello: row.lessondatelevelreached,
  }));
  let totale_ore=0
  for (let i of lez_pac) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
  totale_ore+=diffMs}
  commento.innerText =  `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}`
      e.component.option("dataSource", formattedRows3);
      setTimeout(() => {
            $("#gridContainerSecond").removeClass("grid-container-hidden");
            $("#loadingOverlay").hide();
        }, 100);
        }
    },
    onCellClick: function(e) {
                if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {

      const masterRow = e.component.getRowElement(e.row.rowIndex);
      const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
      if (!($icon.length)) {
      const masterRow = e.component.getRowElement(e.row.rowIndex);
      const $icon = masterRow.find(".dx-datagrid-adaptive-more");
      if ($icon.length){
      $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
      }
      else
      {
      $icon[0].className = "dx-datagrid-adaptive-more";
      }}

    },

    });}

  }, 0);

  return div;
}

function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
const TabellaPacchetti = ({selectedIndex2}) => {
  const gridRef = useRef(null);
  const listinoPrezzi={"Base":{1:80,2:150,3:210,4:270,5:320,6:390,7:440,8:490,9:540,10:570},"Avanzata":{1:90,2:170,3:240,4:300,5:360,6:420,7:450,8:520,9:570,10:600},"Foil":{1:90,2:170,3:240,4:300,5:360,6:420,7:450,8:520,9:570,10:600}}
  const allineamento="center"
  useEffect(() => {
    const fetchPacchetti = async () => {
       $("#loadingOverlay").show();
      $("#gridContainer").addClass("grid-container-hidden")
      const datagen = await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        filtri:{"lessondatestatus":2,"lessonsfrom":inizioP,"lessonsto":fineP},
        azione:'getLessons'
      });
      let conti=await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        azione:'getBillItems'
      });
      let data=[]
      if (selectedIndex2===0)  {data=datagen}
      else   {
        for (let i of datagen) {
            if  (Math.abs(i.lessonhours-i.lessonpacket)>0.05 && i["lessonhours"]<i["lessonpacket"]+0.05) {
                if (selectedIndex2===2 | i["lessonhours"]+0.05>i["lessonpacket"]) {
                    data=[...data,i]
                    }
            }
            else {
                if (selectedIndex2===1) {
                    data=[...data,i]
                    }
            }
        }
      }
      let categorieTotali={}
      let dataSourceNazionalita=[]
      for (let pacchetto of data){
        if (!(pacchetto.lessonstudentorigin in categorieTotali))categorieTotali[pacchetto.lessonstudentorigin]=0
        categorieTotali[pacchetto.lessonstudentorigin]+=1
      }
      for (let nazione in categorieTotali){
        if (parseInt(nazione)!==0)
        dataSourceNazionalita.push({category:dizionarioTraduzioni(lingua,decodificaNazionalita(parseInt(nazione))),valore:categorieTotali[nazione]})
      }
      let categorieTotaliGeneri={}
      let dataSourceGeneri=[]
      for (let pacchetto of data){
        if (!(pacchetto.lessonstudentsex in categorieTotaliGeneri))categorieTotaliGeneri[pacchetto.lessonstudentsex]=0
        categorieTotaliGeneri[pacchetto.lessonstudentsex]+=1
      }
      for (let sesso in categorieTotaliGeneri){
        if (parseInt(sesso)!==0)
        dataSourceGeneri.push({category:parseInt(sesso)===1?dizionarioTraduzioni(lingua,"Uomo"):dizionarioTraduzioni(lingua,"Donna"),valore:categorieTotaliGeneri[sesso]})
      }
      const formattedRows = data.map((row, index) => ({
        id: index,
        lessonid:row.lessonid,
        data: convertDate(row.lessonregdate).toISO({ includeOffset: false }),
        nome: row.lessonstudentname,
        pacchetto: row.lessonpacket,
        tipo:row.lessontype,
        costo: row.lessoncost,
        gruppoSingola: row.lessonnumstudents,
        pagamento: row.lessonpaymentmethod,
        anticipo: row.lessonadvance,
        sconto:row.lessondiscount,
        telefono:row.lessonstudentphone,
        sesso:row.lessonstudentsex,
        eta:row.lessonstudentage,
        origine:row.lessonstudentorigin,
        periodo:[row.lessonclientarrival,row.lessonclientdeparture],
        nonDisp:row.lessonclientunavailable,
        costo_scontato: (row.lessoncost * (1 - (row.lessondiscount || 0) / 100)),
        oreTot:row.lessonhours,
          conto:row.billid,
          invoiceid:row.invoiceid,
      }));
      // Inizializza dxDataGrid
      $("#gridContainer").dxDataGrid({
        dataSource: formattedRows,
        columns: [
          {
            dataField: "data",
            caption: dizionarioTraduzioni(lingua,"Data"),
            sortOrder: "desc",
             hidingPriority:8,
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value,onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          { dataField: "nome", caption: dizionarioTraduzioni(lingua,"Studente"), hidingPriority: 13,alignment:allineamento, },
            {
                dataField: "conto",visible:false,
                editCellTemplate: function (cellElement,cellInfo){
            if ($("#val_conto").length===0) {
                $('<div id="val_conto"></div>').appendTo(cellElement)
            }
             let selectBoxData = conti.map(name => ({ id: name.billid, text: name.billcustomer }));

            $("#val_conto").dxLookup({
  dataSource: selectBoxData,
  valueExpr: "id",
  displayExpr: "text",
  value: cellInfo.value,
  searchEnabled: true,
  showClearButton: true,
  placeholder: "Seleziona...",
  onValueChanged: function (e) {
    cellInfo.setValue(e.value);
  },

  // ---> QUI AGGIUNGIAMO I BOTTONI <---
  fieldTemplate: function (selectedItem, container) {
    const valueText = selectedItem ? selectedItem.text : "";

    const wrapper = $("<div>").css({
      display: "flex",
      alignItems: "center",
      width: "100%"
    });

    // Testo del lookup
    $("<span>")
      .text(valueText)
      .css({ flexGrow: 1, overflow: "hidden", textOverflow: "ellipsis" })
      .appendTo(wrapper);

    const instance = $("#val_conto").dxLookup("instance");

    // Funzione helper blocca apertura popup
    const stop = (e) => e.stopPropagation();

    // BTN MODIFICA
    $("<i class='fa-solid fa-pencil' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          // dentro onClick della matita
const id = instance.option("value");

const conto = conti.find(x => x.billid === id);

openContoFormPopup(
  conto?{nome:conto.billcustomer,data:convertDate(conto.billdate).toISO({includeOffset:false}),
                note:conto.billnotes}: {nome:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false}),
                note:""},false)
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter modificare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    // BTN AGGIUNGI
    $("<i class='fa-solid fa-plus' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        openContoFormPopup(
  { nome: "", note:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false})}, true)
      })
      .appendTo(wrapper);

    // BTN ELIMINA
    $("<i class='fa-solid fa-trash-can' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          // TUO CODICE QUI
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter eliminare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    container.empty().append(wrapper);
  }
});

            },
            },
          {
            dataField: "pacchetto",
            hidingPriority: 12,
            caption: dizionarioTraduzioni(lingua,"Pacchetto"),
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_pacchetto").length===0) {
                $('<div id="val_pacchetto"></div>').appendTo(cellElement)
            }
            $("#val_pacchetto").dxNumberBox({min:0,step:0.5,value:cellInfo.value,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },format:"#0.#'H'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const tipo_lez=$("#val_tipo").dxSelectBox("instance").option("value")
            const n_ore=($("#val_pacchetto").dxNumberBox("instance").option("value"))
                    console.log(tipo_lez)
            $("#val_costo").dxNumberBox("instance").option("value",listinoPrezzi[tipo_lez][n_ore])

            }})
          },
            customizeText: function (e) {
              return `${e.value}H`;}
          },
          { dataField: "tipo", caption: dizionarioTraduzioni(lingua,"Tipo"), alignment:allineamento,hidingPriority: 11,
              customizeText: function(e){
              return dizionarioTraduzioni(lingua,e.value)
              },
              editCellTemplate: function(cellElement,cellInfo) {
          if ($("#val_tipo").length===0) {
                $('<div id="val_tipo"></div>').appendTo(cellElement)
            }
          const dataTipo=[{ID:"Base",name:dizionarioTraduzioni(lingua,"Base")},{ID:"Avanzata",name:dizionarioTraduzioni(lingua,"Avanzata")},{ID:"Foil",name:dizionarioTraduzioni(lingua,"Foil")}]
          $("#val_tipo").dxSelectBox({dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'name',value:cellInfo.value,searchEnabled: false, onValueChanged: function(e) {
              cellInfo.setValue(e.value)

            const tipo_lez=$("#val_tipo").dxSelectBox("instance").option("value")
            const n_ore=($("#val_pacchetto").dxNumberBox("instance").option("value"))
            $("#val_costo").dxNumberBox("instance").option("value",listinoPrezzi[tipo_lez][n_ore])
            },
            })
          }},
          {
            dataField: "gruppoSingola",
            hidingPriority: 6,
            caption: dizionarioTraduzioni(lingua,"Num"),
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_num").length===0) {
                $('<div id="val_num"></div>').appendTo(cellElement)
            }
            $("#val_num").dxNumberBox({min:1,step:1,value:cellInfo.value, onValueChanged: function(e) {
            cellInfo.setValue(e.value)

            }})
          },
            cellTemplate: (cellElement, cellInfo) => {
              const icon = cellInfo.value === 1 ? faUser : faUsers;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                <span>
                  <FontAwesomeIcon icon={icon} /> {cellInfo.value}
                </span>
              );
            },
          },
          {
            dataField: "costo",
            caption: dizionarioTraduzioni(lingua,"Costo"),
            alignment:allineamento,
            hidingPriority: 10,
            calculateDisplayValue: function(rowData) {
    return rowData.costo_scontato ?? rowData.costo;
  },
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo").length===0) {
                $('<div id="val_costo"></div>').appendTo(cellElement)
            }
            $("#val_costo").dxNumberBox({min:0,value:cellInfo.value,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const sconto_att=$("#val_sconto").dxNumberBox("instance").option("value")
            $("#val_costo_scontato").dxNumberBox("instance").option("value",cellInfo.value*(1-sconto_att/100))

            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          {
            dataField: "anticipo",
            caption: dizionarioTraduzioni(lingua,"Anticipo"),
            hidingPriority: 9,
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_anticipo").length===0) {
                $('<div id="val_anticipo"></div>').appendTo(cellElement)
            }
            $("#val_anticipo").dxNumberBox({min:0,value:cellInfo.value,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          { dataField: "pagamento", caption: dizionarioTraduzioni(lingua,"Pagamento"), hidingPriority: 1,alignment:allineamento, },
          { dataField: "origine", caption: dizionarioTraduzioni(lingua,"Nazionalità allievo"), hidingPriority: 2,alignment:allineamento,
          customizeText:function(e){
            return dizionarioTraduzioni(lingua,decodificaNazionalita(e.value))
          },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_origine").length===0) {
                $('<div id="val_origine"></div>').appendTo(cellElement)
            }
            let valore_mappa=[]
            let contatore=0
            while (decodificaNazionalita(contatore)){
                valore_mappa.push({name:decodificaNazionalita(contatore),ID:contatore})
                contatore+=1
            }
            $("#val_origine").dxSelectBox({dataSource:valore_mappa ,valueExpr:"ID",displayExpr:"name", value:cellInfo.value,onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              },
            })
          }
           },
           {
           dataField: "periodo",
            caption: dizionarioTraduzioni(lingua,"Periodo"),
            alignment:allineamento,
            hidingPriority: 7,
            calculateDisplayValue: function(rowData) {
                let stringa=""
                if (rowData["periodo"]){
               if (rowData["periodo"][0] && rowData["periodo"][0]){
                    stringa=`${dizionarioTraduzioni(lingua,"dal")} ${DateTime.fromFormat(rowData["periodo"][0],"yyyyMMdd").toFormat("dd/MM/yyyy")} ${dizionarioTraduzioni(lingua,"al")} ${DateTime.fromFormat(rowData["periodo"][1],"yyyyMMdd").toFormat("dd/MM/yyyy")}`

               }}
               return stringa
            },
            editCellTemplate: function(cellElement,cellInfo){
                if ($("#val_periodo").length===0) {
                    $('<div id="val_periodo"></div>').appendTo(cellElement)
                }
                const start = cellInfo["data"]["periodo"][0] ? DateTime.fromFormat(cellInfo["data"]["periodo"][0], "yyyyMMdd").toJSDate() : null;
                const end = cellInfo["data"]["periodo"][1] ? DateTime.fromFormat(cellInfo["data"]["periodo"][1], "yyyyMMdd").toJSDate() : null;
                $("#val_periodo").dxDateRangeBox({
                startDate: start,
                endDate: end,
                displayFormat: "dd/MM/yyyy",
                startDateLabel: dizionarioTraduzioni(lingua,"Arrivo"),
                endDateLabel: dizionarioTraduzioni(lingua,"Partenza"),
                showClearButton: true,
                openOnFieldClick: true,
                onValueChanged: function(e) {
                    if (!e.value) return;
                    const [newStart, newEnd] = e.value;
                    cellInfo.setValue([(newStart)?!(isNaN(newStart.getTime()))?DateTime.fromJSDate(newStart).toFormat("yyyyMMdd"):null:null,(newEnd)?!(isNaN(newEnd.getTime()))?DateTime.fromJSDate(newEnd).toFormat("yyyyMMdd"):null:null])
                }
            });
            }
           },
           {
            dataField: "nonDisp",
            caption: dizionarioTraduzioni(lingua,"Date non disponibili"),
            visible: false, // colonna nascosta
            editCellTemplate: function(cellElement, cellInfo) {
            if ($("#tagBoxContainer").length===0) {
                $('<div id="tagBoxContainer"></div>').appendTo(cellElement)
            }
            let dateG=cellInfo.value
            let dateCont=[]
            let stringaDate=[]

            if (dateG){
                stringaDate=dateG.split(",");
            }
            for (let data of stringaDate){
                if (data)
               dateCont.push(DateTime.fromFormat(data,"yyyyMMdd").toFormat("dd/MM/yyyy"))
            }
                $("#tagBoxContainer").dxTagBox({
    items: [],
        value:   dateCont,
        placeholder: dizionarioTraduzioni(lingua,"Date non disponibili"),
        showSelectionControls: true,
        acceptCustomValue: true,
        noDataText: "",
        showSelectionControls: false,
        dropDownOptions: {
    contentTemplate: function(e) {
         const selectedDates = ( $("#tagBoxContainer").dxTagBox("instance").option("value")).map(d => {
            const parts = d.split("/"); // dd/MM/yyyy
            return new Date(parts[2], parts[1]-1, parts[0]);
        });
        const $calendarDiv = $('<div id="myCalendar"></div>').css({
    width: "auto",
});
        $calendarDiv.dxCalendar({
            selectionMode: "multiple",
            value: selectedDates,
            onValueChanged: function(calenEvent) {
                if (!calenEvent.value) return;
                const dataS = calenEvent.value.map(date => {
                    return DateTime.fromJSDate(date).toFormat("dd/MM/yyyy")
                });
                $("#tagBoxContainer").dxTagBox("instance").option("value", dataS);
            }
        });

        return $calendarDiv;
    }
},
        onValueChanged: function(e) {
        if ($("#myCalendar").dxCalendar("instance")){
            const selectedDates = ( $("#tagBoxContainer").dxTagBox("instance").option("value")).map(d => {
            const parts = d.split("/"); // dd/MM/yyyy
            return new Date(parts[2], parts[1]-1, parts[0]);})
        if ($("#myCalendar").dxCalendar("instance").option("value").length!==selectedDates.length)
        $("#myCalendar").dxCalendar("instance").option("value",selectedDates)
        let listaM=""
        for (let data of $("#tagBoxContainer").dxTagBox("instance").option("value")){
            listaM+=DateTime.fromFormat(data,"dd/MM/yyyy").toFormat("yyyyMMdd")+","
        }
        cellInfo.setValue(listaM)
        }


    }
});
            }
        },
           { dataField: "eta", caption: dizionarioTraduzioni(lingua,"Età allievo"), hidingPriority: 3,alignment:allineamento,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_eta").length===0) {
                $('<div id="val_eta"></div>').appendTo(cellElement)
            }
            $("#val_eta").dxNumberBox({min:0,value:cellInfo.value,format:"#0.##' anni'",onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            })
          }
           },
           { dataField: "sesso", caption: dizionarioTraduzioni(lingua,"Genere allievo"), hidingPriority: 4,alignment:allineamento,
          customizeText:function(e){
             const mappa={0:dizionarioTraduzioni(lingua,"Non specificato"),1:dizionarioTraduzioni(lingua,"Uomo"),2:dizionarioTraduzioni(lingua,"Donna")}
            return mappa[e.value]
          },
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_sesso").length===0) {
                $('<div id="val_sesso"></div>').appendTo(cellElement)
            }
            const valore_mappa=[{name:dizionarioTraduzioni(lingua,"Non specificato"),ID:0},{name:dizionarioTraduzioni(lingua,"Uomo"),ID:1},{name:dizionarioTraduzioni(lingua,"Donna"),ID:2}]
            $("#val_sesso").dxSelectBox({dataSource:valore_mappa ,valueExpr:"ID",displayExpr:"name", value:cellInfo.value,onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              },
            })
          }
           },
           { dataField: "telefono", caption: dizionarioTraduzioni(lingua,"Numero allievo"), hidingPriority: 5,alignment:allineamento, },

          {dataField: "sconto",visible:false,editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_sconto").length===0) {
                $('<div id="val_sconto"></div>').appendTo(cellElement)
            }
            $("#val_sconto").dxNumberBox({showSpinButtons: true,step:5,min:0,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },value:cellInfo.value,max:100,format:"#0.##'%'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const valore_nuovo=($("#val_costo").dxNumberBox("instance").option("value"))*(1-cellInfo.value/100)
            $("#val_costo_scontato").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }},
          {dataField: "costo_scontato",visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo_scontato").length===0) {
                $('<div id="val_costo_scontato"></div>').appendTo(cellElement)
            }

            const displV=($("#val_costo").dxNumberBox("instance").option("value"))*(1-($("#val_sconto").dxNumberBox("instance").option("value"))/100)
            $("#val_costo_scontato").dxNumberBox({showSpinButtons: true,step:10,min:0,elementAttr: {
        inputmode: "decimal"   // forza tastiera con separatore decimale
    },value:displV,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_costo_scontato").dxNumberBox("instance").option("max",$("#val_costo").dxNumberBox("instance").option("value"))
            const valore_nuovo=(1-(e.value)/($("#val_costo").dxNumberBox("instance").option("value")))*100
            $("#val_sconto").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }
          },
          {
            type: "buttons",
            minWidth:160,
            buttons: [
              {
                hint: dizionarioTraduzioni(lingua,"Modifica"),
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
                {
                  hint: dizionarioTraduzioni(lingua,"Fattura pacchetto"),
                  icon: "none",
                  template: function (cellElement, cellInfo) {
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(<DynamicLessonButton2 cellInfo={cellInfo} />);
                  },
                },
              {
                hint: dizionarioTraduzioni(lingua,"Chiudi pacchetto"),
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template:  function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faLock}
                      color="#007bff"
                      onClick={() => closePacket(cellInfo.data)}
                      //onClick={async () => {
 /* await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    azione: 'sendWhatsappMsg',
     getid:cellInfo.data.lessonid,
     group:"lessons",
     valori:{"text":"Prova messaggio. Hai fatto 0h"}
  });
  await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    azione: 'getRepairs'})
}}*/
                    />
                  );
                },
              },
              {
                hint: dizionarioTraduzioni(lingua,"Elimina"),
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
                {
  hint: dizionarioTraduzioni(lingua,"Dettagli lezioni"),
  icon: "none",
  template: function (cellElement, cellInfo) {
    const root = ReactDOM.createRoot(cellElement.get(0));
    root.render(<DynamicLessonButton cellInfo={cellInfo} />);
  },
}
            ],
          },
        ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "100vh",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: dizionarioTraduzioni(lingua,"Informazioni studente"),
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
}
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                  "data",
                  "nome",
                  {
                    dataField: "pacchetto",
                    label: { text: dizionarioTraduzioni(lingua,"Pacchetto (H)") }  // ← Etichetta personalizzata
                  },
                  "tipo","periodo","nonDisp",
                  "gruppoSingola",
                  {
                    dataField: "costo",
                    label: { text: dizionarioTraduzioni(lingua,"Costo (€)" )}  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "anticipo",
                    label: { text: dizionarioTraduzioni(lingua,"Pagato (€)") }  // ← Etichetta personalizzata
                  },
                  "pagamento","telefono","eta","sesso","origine",
                   {
          dataField: "sconto",
          label: {
            text: dizionarioTraduzioni(lingua,"Sconto (%)"),
          }
        },
        {
          dataField: "costo_scontato",
          label: {
            text: dizionarioTraduzioni(lingua,"Costo scontato"),
          }
        },"conto"
                ],
              },
            ],
          },
        },
        onCellClick: function(e) {
                if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {

  const masterRow = e.component.getRowElement(e.row.rowIndex);
  const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
  if (!($icon.length)) {
  const masterRow = e.component.getRowElement(e.row.rowIndex);
  const $icon = masterRow.find(".dx-datagrid-adaptive-more");
  if ($icon.length){
  $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
  }
  else
  {
  $icon[0].className = "dx-datagrid-adaptive-more";
  }}

},
    onEditorPreparing: function(e) {
  if (e.parentType === "filterRow" && e.dataField === "data") {

    e.editorName = "dxDateBox";  // Forza DateBox come filtro
    e.editorOptions = {
      displayFormat: "dd/MM/yyyy",
      type: "date",
      width: "100%",
      onValueChanged: function(ev) {
        e.setValue(ev.value);  // Applica il filtro
      }
    };
  }
},

    onInitNewRow: function (e) {
  e.data.costo = 0;
  e.data.anticipo=0
  e.data.data = DateTime.now().toISODate();
  e.data.tipo="Base"
  e.data.gruppoSingola=1
  e.data.sconto=0
  e.data.pacchetto=1
  e.data.periodo=[null,null]
},
    onRowRemoving: async function (e) {
    const richiesta=  await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        delId:e.data.lessonid,
        azione:'delLesson',
        return_data:false})
    if (richiesta) {
        const message = `Pacchetto di ${e.data.nome} eliminato con successo`;
        window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);}


},

    onRowInserting: async function (e) {

        // Aggiungi la classe di animazione alla griglia
        $("#loadingOverlay").show();
         $("#gridContainer").addClass("grid-container-hidden");

        // Rimuovi la classe dopo l'animazione

    const dati={billid:e.data.conto?e.data.conto:0,"lessonregdate":convertDate(DateTime.fromISO(e.data.data)),"lessonclientarrival":e["data"]["periodo"][0],"lessonclientdeparture":e["data"]["periodo"][1],"lessonclientunavailable":e.data.nonDisp,"lessonstudentname":e.data.nome,"lessonadvance":e.data.anticipo,"lessoncost":e.data.costo,"lessonnumstudents":e.data.gruppoSingola,"lessonpaymentmethod":e.data.pagamento,"lessontype":e.data.tipo,"lessonpacket":e.data.pacchetto,"lessonstudentphone":e.data.telefono,"lessonstudentsex":e.data.sesso!==null?e.data.sesso:0,"lessonstudentorigin":e.data.origine,"lessonstudentage":e.data.eta!==0?e.data.eta:null,"lessondiscount":e.data.sconto};
    const richiesta= await  funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        valori:dati,
        azione:'setLesson'})
    if (richiesta) {
        const message = `Pacchetto di ${e.data.nome} aggiunto con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);
        window.location.reload()
        }
    },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainer"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
    const dati_n={billid:e.data.conto?e.data.conto:0,'lessondiscount':e.data.sconto,"lessonclientarrival":e["data"]["periodo"][0],"lessonclientdeparture":e["data"]["periodo"][1],"lessonclientunavailable":e.data.nonDisp,"lessonstudentphone":e.data.telefono,"lessonstudentsex":e.data.sesso!==null?e.data.sesso:0,"lessonstudentorigin":e.data.origine,"lessonstudentage":e.data.eta!==0?e.data.eta:null,'lessonstudentname':e.data.nome,'lessonregdate':convertDate(DateTime.fromISO(e.data.data)),'lessonpacket':e.data.pacchetto,'lessontype':e.data.tipo,'lessoncost':e.data.costo,'lessonnumstudents':e.data.gruppoSingola,'lessonpaymentmethod':e.data.pagamento,'lessonadvance':e.data.anticipo};
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.lessonid,
        valori:dati_n,
        azione:'setLesson'})
        if (richiesta) {
        const message = `Pacchetto di ${e.data.nome} modificato con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainer',
        },}, "success", 1000);
        }
    },
        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainer").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
          if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const anticipo = parseEuro(e.data.anticipo);
            const costo = parseEuro(e.data.costo_scontato);

            if (!isNaN(anticipo) && !isNaN(costo) && Math.abs(anticipo - costo) > 0.01) {
              e.rowElement.addClass("row-warning");
              $(e.rowElement).css("background-color", "#ffe6e6")
            }
          }
        },
      });
      $("#chartPieNazionalita").dxPieChart({
  dataSource: dataSourceNazionalita,
  width:"50%",
  height:"100%",
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>${dizionarioTraduzioni(lingua,"Categoria")}:</b> ${pointInfo.argument}<br>
            <b>${dizionarioTraduzioni(lingua,"Valore")}:</b> ${pointInfo.value} ${dizionarioTraduzioni(lingua,"Persone")} <br>
            <b>${dizionarioTraduzioni(lingua,"Percentuale")}:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
    },
  series: {

    argumentField: "category",
    valueField: "valore",
    label: {
      visible: true,
      connector: {
        visible: false,
      },
    },
  },
  export: {
    enabled: true,
    formats: ['PNG', 'PDF', 'JPEG', 'SVG'],
    fileName: "grafico",
  },
  title: dizionarioTraduzioni(lingua,"Suddivisione nazionalità"),
});
$("#chartPieGeneri").dxPieChart({
  dataSource: dataSourceGeneri,
  width:"50%",
  height:"100%",
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>${dizionarioTraduzioni(lingua,"Categoria")}:</b> ${pointInfo.argument}<br>
            <b>${dizionarioTraduzioni(lingua,"Valore")}:</b> ${pointInfo.value} ${dizionarioTraduzioni(lingua,"Persone")} <br>
            <b>${dizionarioTraduzioni(lingua,"Percentuale")}:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
    },
  series: {

    argumentField: "category",
    valueField: "valore",
    label: {
      visible: true,
      connector: {
        visible: false,
      },
    },
  },
  export: {
    enabled: true,
    formats: ['PNG', 'PDF', 'JPEG', 'SVG'],
    fileName: "grafico",
  },
  title: dizionarioTraduzioni(lingua,"Suddivisione genere"),
});
    };

    fetchPacchetti();
    $("#popupContoEdit").dxPopup({
  width: "90%",
  height: "auto",
  showTitle: true,
  title: dizionarioTraduzioni(lingua,"Gestisci conto"),
  dragEnabled: false,
  hideOnOutsideClick: true
});
    $("#fattura").dxPopup({
    width: "90%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
 showCloseButton:true,
    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollFattura" style="height: 100%;"></div>');
    $("#customScrollFattura").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    },
    });
    $("#chiusuraPacchetto").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    });
    $("#infoPopup").dxPopup({
    width: "80%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    hideOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const $content = $(e.component.content());
    const $scroll = $("#customScroll");

    if ($scroll.length) {
        if ($scroll.data("dxScrollView")) {
            $scroll.dxScrollView("instance").dispose();
        }
        $scroll.remove();
    }

    $content.wrapInner('<div id="customScroll" style="height: 100%;"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
}

});

  }, []);

  return (

    <div id="gridContainer" ref={gridRef}></div>
  );
}
return (<div id="app" style={{ padding: "0px" }}>

    <TabellaPacchetti selectedIndex2={selectedIndex2} />
    <div style={{display:"flex",width:"100%",height:"auto",alignItems: "center",justifyContent: "space-between",}}>
        <div id="chartPieNazionalita"></div>
        <div id="chartPieGeneri"></div>
    </div>
    <div id="popupContoEdit"></div>
    <div id="chiusuraPacchetto" />
    <div id="fattura" />
    <div style={{padding:"30px"}} id="infoPopup">
      <div className="popup-content">
      </div>
    </div>
    <div id="loadingOverlay">
      <div className="spinner">
        <Lottie  style={{ width: "100%", height: "100%" }} animationData={animLoading2} loop={true} />
      </div>
    </div>
  </div>)
}

export default TabellaLezioni;
